interface Props {
  patch: string
  className?: string
}

/**
 * Minimal unified-diff renderer. No syntax highlighting; just colour-coded
 * +/-/@@ lines on a monospace background. Mature diff libraries pull in
 * hundreds of KB; this stays under 1 KB.
 */
export default function DiffView({ patch, className }: Props) {
  const lines = patch.replace(/\r\n/g, '\n').split('\n')

  return (
    <pre
      className={`text-[11px] font-mono leading-relaxed overflow-x-auto rounded-md bg-black/30 border border-white/5 p-3 ${className ?? ''}`}
      style={{ color: 'var(--text-primary)' }}
    >
      <code>
        {lines.map((line, i) => {
          const style = lineStyle(line)
          return (
            <span key={i} style={{ display: 'block', ...style }}>
              {line || ' '}
            </span>
          )
        })}
      </code>
    </pre>
  )
}

function lineStyle(line: string): React.CSSProperties {
  // Headers
  if (line.startsWith('---') || line.startsWith('+++')) {
    return { color: 'var(--text-muted)' }
  }
  if (line.startsWith('@@')) {
    return { color: 'var(--accent)', opacity: 0.85 }
  }
  // Additions / deletions / context
  if (line.startsWith('+')) {
    return { color: 'var(--score-good)', background: 'rgba(34,197,94,0.07)' }
  }
  if (line.startsWith('-')) {
    return { color: 'var(--score-poor)', background: 'rgba(239,68,68,0.07)' }
  }
  return { color: 'var(--text-secondary)' }
}
